import { render, staticRenderFns } from "./validateLevels.vue?vue&type=template&id=0ca48c56&scoped=true"
import script from "./validateLevels.vue?vue&type=script&lang=js"
export * from "./validateLevels.vue?vue&type=script&lang=js"
import style0 from "./validateLevels.vue?vue&type=style&index=0&id=0ca48c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca48c56",
  null
  
)

export default component.exports